import { Injectable, effect, signal } from '@angular/core';

const STORAGE_KEY = 'privanot.developerMode';

@Injectable({ providedIn: 'root' })
export class DeveloperModeService {
    public readonly enabled = signal<boolean>(this.read());

    constructor() {
        effect(() => {
            const on = this.enabled();
            try {
                localStorage.setItem(STORAGE_KEY, on ? '1' : '0');
            } catch {
                // intentionally empty
            }
        });
    }

    public toggle(): void {
        this.enabled.update((v) => !v);
    }

    public setEnabled(value: boolean): void {
        this.enabled.set(value);
    }

    private read(): boolean {
        try {
            return localStorage.getItem(STORAGE_KEY) === '1';
        } catch {
            return false;
        }
    }
}
